import { render } from "./devops-integration.vue?vue&type=template&id=0afacba4"
import script from "./devops-integration.vue?vue&type=script&lang=js"
export * from "./devops-integration.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Master\\vue-notus-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__